import epicLabel from "./epic_pass.png";
import Session from "@lib/session";
import removeEpicPass from "@lib/services/remove_epic_pass";

export default function Epic({
  className = "",
  hideRemove = false,
}: {
  className?: string;
  hideRemove?: boolean;
}) {
  const epicId = Session.getBooking().otherInfo.epicPassId;
  if (!epicId) return null;

  async function removeEpic() {
    await removeEpicPass();
    window.location.reload();
  }

  return (
    <div className={`${className} flex items-center font-number`}>
      <img src={epicLabel.src} alt="Epic ID" className="h-6 mr-3" />
      <span className="-mt-1.5">{epicId}</span>
      {!hideRemove && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="#ee6b0a"
          className="ml-1.5 -mt-1.5 w-5 h-5 cursor-pointer hover:opacity-50"
          onClick={removeEpic}
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z"
            clipRule="evenodd"
          />
        </svg>
      )}
    </div>
  );
}
